export default "__VITE_ASSET__jZVhJvXm__"